export enum AmazonCategory {
    ItemType = 'item-type',
    ProductType = 'product-type'
}
